import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { ApiStartLocalPqRunResponse, StartLocalPqRunRequest } from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export function useStartLocalPqRunMutation(
  options?: UseMutationOptions<ApiStartLocalPqRunResponse, StartLocalPqRunRequest>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (request: StartLocalPqRunRequest) => pqClient.startRun(request),
  })

  return { startRun: mutateAsync, ...mutationResult }
}
